export enum WicketAdminPublicationStatus {
  DRAFT = 'DRAFT',
  SCHEDULED = 'SCHEDULED',
  DELETED = 'DELETED',
  STARTED = 'STARTED',
}
